import * as React from 'react';

import { EntityDetails } from '@rematter/ui-web';
import { useAtom, useAtomValue } from 'jotai';

import {
  $organization,
  $remoteOrganizations,
  $tab,
  type OrganizationDetailTab,
} from '../../_state/organizationDetail.state';
import { useTranslations } from '../../i18n/useTranslations';
import { adminRoutes } from '../../routes';

import { OrganizationTabDetails } from './OrganizationTabDetails';
import { OrganizationTabEntitlements } from './OrganizationTabEntitlements';

import { useModuleLocation } from '~/shared/hooks/useModuleLocation';

//
// ⚛️ ⚛️ ⚛️ ORGANIZATION DETAIL VIEW ⚛️ ⚛️ ⚛️
//
export const OrganizationDetailView: React.FC = () => {
  const t = useTranslations();
  const [, navigate] = useModuleLocation();

  const { isLoading, error } = useAtomValue($remoteOrganizations);
  const organization = useAtomValue($organization);
  const [tab, setTab] = useAtom($tab);

  const activeTab = (tab || 'details') as OrganizationDetailTab;

  const handleBack = React.useCallback(() => {
    navigate(adminRoutes.organizations);
  }, [navigate]);

  return (
    <div className="@OrganizationDetailView flex h-full flex-col">
      <EntityDetails
        className="h-full"
        onBackPressed={handleBack}
        primaryTitle={organization?.name ?? ''}
        subtitle={organization?.domain ?? undefined}
        loading={isLoading}
        error={error}
        tabs={{
          details: {
            title: t.organizationDetailView.tabs.details,
            content: OrganizationTabDetails,
          },
          entitlements: {
            title: t.organizationDetailView.tabs.entitlements,
            content: OrganizationTabEntitlements,
          },
        }}
        currentTab={activeTab}
        onChangeTab={(t) => setTab(t as OrganizationDetailTab)}
      />
    </div>
  );
};
